import React from 'react';
import ErrorUtils from 'src/utils/ErrorUtils';
import ServiceCollection from 'src/services/ServiceCollection';
import TPEAction from 'src/models/common/TPEAction';
import { CreateWizardState } from 'src/services/segment-cdt/SegmentTablesState';
import { ACTIONS } from 'src/services/segment-cdt/SegmentTablesReducer';
import { buildCreateRequest } from 'src/components/segment-cdt/create/segmentCreateUtils';

/**
 * Submit the create wizard: calls `CreateSegmentDataTable` exactly once (guarded against
 * double-submit), then success banner + REFRESH + close, or surfaces the server's 417 message inline.
 * No pull/populate happens at create. Extracted from the wizard so it is unit-testable without the
 * Cloudscape modal portal.
 */
export async function submitCreate(
    cw: CreateWizardState,
    services: ServiceCollection,
    dispatch: React.Dispatch<TPEAction>,
): Promise<void> {
    if (cw.creating) {
        return;
    }
    dispatch(ACTIONS.SET_CREATE_ERROR.withPayload(''));
    dispatch(ACTIONS.SET_CREATING.withPayload(true));
    try {
        const resp = await services.segmentDataTablesService.createSegmentDataTable(buildCreateRequest(cw));
        services.messageService.showSuccessAutoDismissBanner(`${resp?.tableName ?? cw.tableName} successfully created.`, 10000);
        dispatch(ACTIONS.REFRESH);
        dispatch(ACTIONS.CLOSE_CREATE_WIZARD);
    } catch (ex) {
        dispatch(ACTIONS.SET_CREATE_ERROR.withPayload(ErrorUtils.getMessage(ex)));
        dispatch(ACTIONS.SET_CREATING.withPayload(false));
    }
}
